import React, { useContext, useState, useEffect } from 'react'

import { GlobalContext } from '../../lib-atomic-context'

import {
  Box,
  Container,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Typography,
} from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'

const index = (props) => {
  const { pages } = useContext(GlobalContext)
  const { masterpages } = pages.state.data
  const { header, subtitle, json } =
    masterpages && masterpages.length > 0 ? masterpages[0] : null
  return (
    <Container
      component={Box}
      my={5}
      maxWidth="sm"
      disableGutters
      style={{ paddingLeft: 20, paddingRight: 20 }}
    >
      {header && header.length > 0 ? (
        <Typography
          color="primary"
          variant="h4"
          gutterBottom
          className="subway-footlong"
        >
          {header}
        </Typography>
      ) : null}
      {json && json.privacy && (
        <Box my={3}>
          {json.privacy.title && json.privacy.title.length > 0 ? (
            <Typography
              key={index}
              color="primary"
              variant="h5"
              gutterBottom
              className="subway-footlong"
            >
              {json.privacy.title}
            </Typography>
          ) : null}

          {json.privacy.subtitle && json.privacy.subtitle.length > 0 ? (
            <Typography
              style={{ marginTop: 10 }}
              gutterBottom
              className="subway-six-inch"
            >
              {
                <div
                  dangerouslySetInnerHTML={{ __html: json.privacy.subtitle }}
                />
              }
            </Typography>
          ) : null}

          {json.privacy.title2 && json.privacy.title2.length > 0 ? (
            <Typography
              key={index}
              color="primary"
              variant="h5"
              gutterBottom
              className="subway-footlong"
            >
              {json.privacy.title2}
            </Typography>
          ) : null}

          {json.privacy.subtitle2 && json.privacy.subtitle2.length > 0 ? (
            <Typography
              style={{ marginTop: 10 }}
              gutterBottom
              className="subway-six-inch"
            >
              {
                <div
                  dangerouslySetInnerHTML={{ __html: json.privacy.subtitle2 }}
                />
              }
            </Typography>
          ) : null}
          <Box my={3}>
            {json.privacy.contents &&
              json.privacy.contents.length > 0 &&
              json.privacy.contents.map(({ q, a }, index) => (
                <ExpansionPanel key={index}>
                  <ExpansionPanelSummary
                    expandIcon={<AddIcon />}
                    aria-controls={`q${index}bh-content`}
                    id={`q${index}bh-header`}
                  >
                    <Typography
                      color="primary"
                      variant="h6"
                      className="subway-footlong"
                    >
                      <a
                        name={index + 1}
                        style={{
                          display: 'block',
                          position: 'relative',
                          top: -90,
                          visibility: 'hidden',
                        }}
                      />
                      <div dangerouslySetInnerHTML={{ __html: q }} />
                    </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <Typography
                      variant="body2"
                      style={{ 'white-space': 'pre-wrap', fontSize: 16 }}
                      className="subway-six-inch"
                    >
                      <div dangerouslySetInnerHTML={{ __html: a }} />
                    </Typography>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              ))}
          </Box>
        </Box>
      )}
    </Container>
  )
}

export default index
